// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stockNameTxtChange{font-size:15px;font-weight:500;position:relative;color:#fa6759}.stockNameTxtChange:after{content:\"\";position:absolute;left:0;bottom:-6px;width:100%;height:2px;background-color:#fecbcb}@media screen and (max-width:1000px){.themeListMobile{display:inline-flex;font-size:12px}.stockNameTxtChange{display:inline-block;vertical-align:middle;font-weight:500;position:relative;color:#fa6759}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
